<article class="mobile-app-card">
  <img
    [src]="mobileApp.icon"
    [alt]="mobileApp.name"
    class="mobile-app-image mb16"
  >
  <span [matTooltip]="mobileApp.name" class="h4 mb12 app-name">
    {{ mobileApp.name }}
  </span>
  <div class="marketplace-wrapper ml8">
    @for (platform of platforms; track platform.platform) {
      @if (platform.apps.length === 1) {
        <a
          [href]="platform.apps[0].link"
          target="_blank"
          rel="nofollow"
          class="appstore-link"
        >
          <svg [icon]="getStoreIcon(platform.apps[0].name)" class="svg24 inactive-color"/>
        </a>
      } @else {
        <button
          class="btn-empty icon-btn appstore-link"
          [matMenuTriggerFor]="menu"
        >
          <svg [icon]="getStoreIcon(platform.apps[0].name)" class="svg24 inactive-color"/>
        </button>

        <mat-menu #menu="matMenu" yPosition="below">
          @for (app of platform.apps; track app.name) {
            <a mat-menu-item [href]="app.link" target="_blank" rel="nofollow" class="menu-item-row">
              <svg [icon]="appIcon" class="svg24 inactive-color" />
              <span>{{ app.store }}</span>
            </a>
          }
        </mat-menu>
      }
    }
  </div>
</article>
